define([
    'lodash',
    'prop-types',
    'componentsCore',
    'mediaControls/utils/mediaControlsUtils'
], function (_, PropTypes, componentsCore, mediaControlsUtils) {
    'use strict';

    const COMP_BASE_HEIGHT = 58;
    const COMP_BASE_BORDER_WIDTH = 2;

    const getReadableTime = mediaControlsUtils.getReadableTime;
    /**
     * @class components.MediaControlStoryboard
     * @extends {core.skinBasedComp}
     */

    return {
        displayName: 'MediaControlStoryboard',
        mixins: [componentsCore.mixins.skinBasedComp, componentsCore.mixins.createChildComponentMixin],

        propTypes: {
            style: PropTypes.object,
            svgPropsMapForMediaControls: PropTypes.object.isRequired,
            hidden: PropTypes.bool,
            showVideo: PropTypes.bool,
            setStateCallback: PropTypes.func.isRequired,
            storyboardUrl: PropTypes.string,
            videoAspectRatio: PropTypes.number,
            playbackErrorCallback: PropTypes.func
        },

        getInitialState() {
            return {
                time: 0,
                left: 0
            };
        },

        getDefaultProps() {
            return {
                playbackErrorCallback: _.noop
            };
        },

        componentDidMount() {
            this.props.setStateCallback(this.setState.bind(this));
        },

        componentWillUnmount() {
            this.props.setStateCallback(null);
        },

        componentDidUpdate(prevProps, prevState) {
            if (this.props.showVideo) {
                if (this.refs.mediaSource) {
                    this.refs.mediaSource.addEventListener('error', this.handlePlaybackError, true);
                }
                const videoElement = this.refs.video;
                if (this.props.storyboardUrl !== videoElement.currentSrc) {
                    videoElement.load();
                }
                if (videoElement && prevState.time !== this.state.time) {
                    videoElement.currentTime = this.state.time;
                }
            }
        },

        handlePlaybackError(/*event*/) {
            //notify parent that playback has an error
            this.props.playbackErrorCallback();
        },

        getPreviewDimensions(videoAspectRatio) {
            const componentWidth = Math.round(COMP_BASE_HEIGHT * videoAspectRatio);
            return {
                width: componentWidth + COMP_BASE_BORDER_WIDTH * 2, // eslint-disable-line no-mixed-operators
                height: COMP_BASE_HEIGHT + COMP_BASE_BORDER_WIDTH * 2 // eslint-disable-line no-mixed-operators
            };
        },

        /**
         * Get a vectorImage by current symbol name
         * @param {string} iconSymbolName
         * @returns {ReactCompositeComponent}
         */
        getIconComponent(iconSymbolName) {
            const iconProps = _.get(this.props.svgPropsMapForMediaControls, iconSymbolName);
            const props = _.assign({
                id: `${this.props.id}icon`,
                key: iconSymbolName,
                ref: 'icon',
                preserveViewBox: true
            }, iconProps);
            return iconProps ? this.createChildComponent(null, 'wysiwyg.viewer.components.VectorImage', 'icon', props) : null;
        },

        getSkinProperties() {
            const style = {
                left: this.state.left,
                visibility: this.props.hidden ? 'hidden' : 'visible'
            };

            const videoDimensions = this.getPreviewDimensions(this.props.videoAspectRatio);

            if (this.props.showVideo) {
                style.top = -COMP_BASE_HEIGHT;
                return {
                    '': {
                        style: _.defaults(style, videoDimensions, this.props.style)
                    },
                    video: {
                        onError: this.handlePlaybackError
                    },
                    mediaSource: {
                        src: this.props.storyboardUrl,
                        onError: this.handlePlaybackError
                    },
                    label: {
                        children: [getReadableTime(this.state.time)]
                    }
                };
            }

            return {
                '': {
                    style
                },
                icon: this.getIconComponent('storyboardTime'),
                label: {
                    children: [getReadableTime(this.state.time, 60 * 60 - 1)] // eslint-disable-line no-mixed-operators
                }
            };
        }
    };
});
